import React, { useEffect, useState } from 'react'
import ProjectReviewTable from './ProjectReviewTable'
import * as moment from 'jalali-moment';
import "./ProjectReview.scss"
import { useNavigate } from 'react-router-dom';
import Axios from 'middleware/axiosInstance';

const ProjectReview = () => {

    const navigate = useNavigate();

    // check if project is offlineMode
    const isOfflineMode = JSON.parse(sessionStorage.getItem("is-offline-mode"))
    const selectedItems = JSON.parse(sessionStorage.getItem('projectItems'))
    const employerSignature = sessionStorage.getItem('employer-signuture')
    const technicianSignature = sessionStorage.getItem('technician-signuture')
    const apiToken = localStorage.getItem("token")
    const startTime = sessionStorage.getItem('start-time')
    const endTime = sessionStorage.getItem('end-time')
    const description = sessionStorage.getItem('description') || "توضیحات ندارد!"
    const employerName = sessionStorage.getItem('employer-name')
    const projectId = sessionStorage.getItem('project-id')
    const technecianName = localStorage.getItem('name')
    const origin = sessionStorage.getItem('origin') || "11.11111"
    const destination = sessionStorage.getItem('destination') || "22.22222"
    const distance = sessionStorage.getItem('distance')

    /* seprate used item name, units of used item and value of used item in project in 3 array to send 
     in standard format (to send with api) */
    // name of used item in project
    const usedItemsInProject = []

    // unit of used item in project
    const unitOfItems = []

    // unit of used item in project
    const valueOfItems = []

    const [reportProject, setReportProject] = useState()
    const [inProcess, setInProcess] = useState(false)
    useEffect(() => {
        setReportProject({
            api_token: apiToken,
            origin: origin,
            destination: destination,
            distance: distance,
            description: description,
            start_time: startTime,
            end_time: endTime,
            technician_signature: technicianSignature,
            employer_signature: employerSignature,
            used_items: `[${usedItemsInProject}]`,
            units: `[${unitOfItems}]`,
            used_values: `[${valueOfItems}]`,
            technician_name: technecianName,
            project_name: employerName,
            project_id: projectId
        })
    },[]);


    const handleSubmit = () => isOfflineMode ? saveReportToDraft() : sendReportToServer()

    selectedItems.map(item => {
        usedItemsInProject.push(`"${item.itemName}"`)
        unitOfItems.push(`"${item.itemUnit}"`)
        valueOfItems.push(`"${item.itemValue}"`)
    }
    )

    const saveReportToDraft = () => {
        try {
            const allSavedProjectsInStorage = localStorage.getItem('all-saved-projects-in-storage') == null ?
                [] : JSON.parse(localStorage.getItem('all-saved-projects-in-storage'))
            let dateNowInJalali = moment().locale('fa').format('YYYY/M/D HH:mm');
            const projectInfo = { employerName, projectId, dateDraftCreated: dateNowInJalali, technecianName }
            var reportTemp = { projectInfo, reportProject }
            allSavedProjectsInStorage.push(reportTemp)
            localStorage.setItem('all-saved-projects-in-storage', JSON.stringify(allSavedProjectsInStorage))

            sessionStorage.clear();
            alert("گزارش شما با موفقیت در پیش نویس ها قرار گرفت و آماده ارسال است")

            navigate("/projects");
        }

        catch {
            alert("در فرایند ذخیره سازی مشکلی پیش آمده است، پروژه ذخیره نشد")
        }
    }


    const sendReportToServer = async () => {
        console.log(reportProject);
        setInProcess(true)
        try {
            // const apiRoute = `create/report/project/${projectId}`
            const apiRoute = `setitems/projreport`
            const config = {
                headers: {
                    'accept': 'application/json',
                }
            }
            await Axios.post(apiRoute, reportProject, config)
                .then(res => {
                    alert(res.data.message)
                    setInProcess(false)
                    sessionStorage.clear();
                    navigate("/services");
                })
        }
        catch {
            setInProcess(false)
            saveReportToDraft()
            alert("به خطا خوردیم ولی پروژه رو به صورت پیش نویس ذخیره کردیم")
            navigate("/projects");
        }
    }

    return (
        <div className="main-container page-content-center" >
            <div className="form-container-border d-flex flex-column justify-content-center">
                <ProjectReviewTable
                    isOfflineMode={isOfflineMode}
                    employerName={employerName}
                    startTime={startTime}
                    endTime={endTime}
                    selectedItems={selectedItems}
                    description={description}
                    employerSignature={employerSignature}
                    technicianSignature={technicianSignature}
                    handleSubmit={handleSubmit}
                    inProcess={inProcess}
                    projectId={projectId}
                />
            </div>
        </div >
    )
}

export default ProjectReview